"use client";

import { MAIN_SITE_ROUTES } from "@frontend/roz-sdk-core";
import { Button } from "@frontend/roz-uikit/studio";
import type { ReactNode } from "react";

import {
  HeaderAuth,
  MenuTrigger,
  RegionSelector,
  SearchTrigger,
} from "@/atoms/header";
import { HeaderShell } from "@/layout";
import { cn } from "@/lib/cn";
import { Logo, NavLink } from "@/primitives";
import { useSdkConfig } from "@/provider";
import type { HeaderConfig } from "@/types";

export interface StandardHeaderProps extends HeaderConfig {
  className?: string;
  variant?: "sticky" | "static";
  logo?: ReactNode;
  nav?: ReactNode;
}

export const StandardHeader = ({
  className,
  variant,
  logo,
  nav,
  searchEnabled,
  profileLink,
  logoLink,
}: StandardHeaderProps) => {
  const config = useSdkConfig();
  const isDarkHeader = config.theme === "dark";

  return (
    <HeaderShell
      className={cn(
        isDarkHeader
          ? "sdkui:border-white/10 sdkui:bg-dark-100/72 sdkui:text-white"
          : "sdkui:border-black/5 sdkui:bg-zinc-50/72 sdkui:text-dark-100",
        className
      )}
      variant={variant}
    >
      <HeaderShell.Left>
        {logo ?? <Logo href={logoLink} />}
        <RegionSelector compactOnTablet />
      </HeaderShell.Left>

      <HeaderShell.Center className="sdkui:lg:absolute sdkui:lg:top-1/2 sdkui:lg:left-1/2 sdkui:lg:w-[462px] sdkui:lg:max-w-none sdkui:lg:flex-none sdkui:lg:-translate-x-1/2 sdkui:lg:-translate-y-1/2">
        {searchEnabled ? <SearchTrigger /> : null}
      </HeaderShell.Center>

      <HeaderShell.Right>
        {nav ?? (
          <>
            <Button
              asChild
              className={cn(
                "sdkui:hidden sdkui:px-6 sdkui:font-medium sdkui:text-sm sdkui:lg:inline-flex",
                isDarkHeader
                  ? "sdkui:text-white sdkui:hover:text-white sdkui:focus-visible:text-white sdkui:active:text-white"
                  : "sdkui:text-dark-100"
              )}
              size="lg"
              variant="ghostPrimary"
            >
              <NavLink href={MAIN_SITE_ROUTES.events}>Мероприятия</NavLink>
            </Button>
            <HeaderAuth profileLink={profileLink} />
            <MenuTrigger />
          </>
        )}
      </HeaderShell.Right>
    </HeaderShell>
  );
};
